// Copyright (c) Docugami, Inc. All rights reserved.

import { ZapierWorkflow } from "components/zapier/ZapierWorkflow"
import styled from "styled-components"

const Container = styled.div`
    margin: 20px;
    width: 100%;
    height: 100%;
`
export const ZapierWorkflowPage = (): JSX.Element => {
    return (
        <Container>
            <ZapierWorkflow />
        </Container>
    )
}
